<template>
  <div class="share-poster" v-if="showModal">
    <!-- 分享弹框 -->
    <van-popup v-model="showShare" class="share-modal" @close="closeShare">
      <div class="share-content" v-if="!loading">
        <div class="share-box">
          <img class="share-box-img" :src="imgPath" alt="" />
        </div>
        <div class="share-btn-box" v-if="inApp">
          <div class="share-btn-item">
            <img
              @click="appShare(3, 1)"
              class="share-btn-icon"
              src="https://editor.xesimg.com/tailor/resource/share-friend-icon-1618294199964.png"
              alt=""
            />
            <div class="share-btn-text">微信好友</div>
          </div>
          <div class="share-btn-item">
            <img
              @click="appShare(2, 2)"
              class="share-btn-icon"
              src="https://editor.xesimg.com/tailor/resource/share-circle-icon-1618294199963.png"
              alt=""
            />
            <div class="share-btn-text">朋友圈</div>
          </div>
          <div class="share-btn-item">
            <img
              @click="appShare(2, 32)"
              class="share-btn-icon"
              src="https://editor.xesimg.com/tailor/resource/share-save-icon-1618294199966.png"
              alt=""
            />
            <div class="share-btn-text">保存图片</div>
          </div>
        </div>
        <div class="share-h5" v-if="!inApp">
          <div>长按/截图保存图片，分享给好友</div>
        </div>
        <img
          class="close-btn"
          @click="closeShare"
          src="https://editor.xesimg.com/tailor/resource/live-success-btn-1618295882969.png"
          alt=""
        />
      </div>
      <van-loading v-if="loading" />
    </van-popup>
  </div>
</template>

<script>
import { drawPoster } from './../utils'
import { browser } from '@/common/utils/xesFunction'
import { callAppShare } from './app'
import { mapState } from 'vuex'
import qs from 'querystring'
export default {
  name: 'SharePoster',
  data() {
    return {
      loading: true,
      showModal: false,
      showShare: false,
      inApp: true,
      imgPath: '',
      env: '',
      qrcode: '',
      activityId: 'summerCamp',
      posterBg_0: 'https://editor.xesimg.com/tailor/resource/dwed1-1623243725917.png', // 邀请好友助力分享
      posterBg_1: 'https://editor.xesimg.com/tailor/resource/213121-1623814149835.png', // 分享作文详情
      posterBg_2: 'https://editor.xesimg.com/tailor/resource/newposter2-1623226794678.png', // 夏令营活动分享海报
      posterBg_3: 'https://editor.xesimg.com/tailor/resource/rwerwer1-1623251340978.jpg' // 笔尖活动分享海报
    }
  },
  computed: {
    ...mapState.myUserId
  },
  // type 0: 分享自己的 1 分享他人 2 分享活动
  props: ['userName', 'headImg', 'type', 'articleId'],
  async created() {
    // this.urlParams = getUrlParmas(window.location.href) || {}
    this.sourceId =
      window._wltfChannel.urlParams.xeswx_sourceid ||
      window._wltfChannel.urlParams.sourceId ||
      window._wltfChannel.hotUrlParams.source ||
      window._wltfChannel.urlParams.sourceid ||
      ''
    this.inApp = browser.isApp
    this.userId = this.myUserId || this.$xesCookie.get('stu_id')
    this.env = window._wltfChannel.urlParams.env || ''
    console.log('window._wltfChannel', window._wltfChannel.urlParams)
    // 查看是否有证书
  },
  methods: {
    async getSmallProgramCode() {
      const res = await this.$api.getWxAppCode({
        params: {
          userId: this.userId,
          sGroupId: '691001',
          sourceId: this.sourceId || '1',
          activityId: this.activityId,
          env: this.env,
          redirectUrl: encodeURIComponent(this.redirectUrl)
        }
      })
      console.log('res', res)
      if (res && res.data && res.data.url) {
        this.qrcode = res.data.url
        // this.qrcode = 'https://editor.xesimg.com/tailor/resource/share-poster-voice-1618436865802.png'
        try {
          this.imgPath = await drawPoster({
            posterBg: this[`posterBg_${this.type}`],
            code: this.qrcode,
            userName: this.userName,
            headImg: this.headImg,
            type: this.type
          })
        } catch (error) {
          this.$xesLogger.clickMsg({
            params: {
              clickid: '13.0.0',
              elemname: '分享海报绘制失败',
              error,
              resQrcode: this.qrcode
            }
          })
        }

        this.loading = false
      } else {
        // this.showModal = false
        // this.showShare = false
        this.loading = false
        this.$toast('获取小程序二维码异常')
      }
    },
    getRedirectUrl() {
      const flag = /\?/.test(location.search) ? '&' : '?'
      const query = this.$route.query
      this.redirectUrl = `https://activity.xueersi.com/advance/summerCamp/${
        location.search
      }${flag}inviterId=${this.userId}&articleId=${this.articleId || query.articleId}&isSelf=${query.isSelf ||
        0}&from=miniprogram#/helpPage`
      this.activityId = 'summerCamp'
      if (this.type === 2) {
        // 分享活动-夏令营活动海报
        this.activityId = 'summerCampLottery'
        const channelId = window._wltfChannel.urlParams.channelId || ''
        // this.redirectUrl = 'https://activity.xueersi.com/advance/teacherDay/#/'
        this.redirectUrl = `https://activity.xueersi.com/advance/summerCampLottery/${location.search}${flag}inviterId=${this.userId}&channelId=${channelId}&from=miniprogram#/`
      }
      if (this.type === 3) {
        this.redirectUrl = `https://activity.xueersi.com/advance/summerCamp/${location.search}#/`
      }
      console.log('redirectUrl', this.redirectUrl)
    },
    async show() {
      console.log('show')
      this.showModal = true
      this.showShare = true
      this.getRedirectUrl()
      await this.getSmallProgramCode()
    },
    closeShare() {
      setTimeout(() => {
        this.showShare = false
        this.loading = true
      }, 500)
      this.showModal = false
    },
    async saveShareMessage() {
      const res = await this.$api.appCodeBind({
        params: {
          userId: this.userId,
          sGroupId: '691001',
          sourceId: this.sourceId,
          activityId: this.activityId,
          env: this.env,
          redirectUrl: encodeURIComponent(this.redirectUrl)
        }
      })
      if (res.code === 0) {
        this.shareParam = encodeURIComponent(
          qs.stringify({
            u: this.userId,
            s: '691001',
            id: res.data.id
          })
        )
        console.log('this.shareParam', this.shareParam)
      } else {
        this.$toast(res.msg || '错误')
      }
    },
    async appShare(shareType, scence) {
      console.log({ shareType, scence })
      let path = ''
      if (shareType === 3) {
        await this.saveShareMessage()
        path = `pages/home?scene=${this.shareParam}&env=${this.env}`
      }
      if (shareType === 3 && !path) {
        this.$toast('小程序分享路径不存在')
      }
      // app内分享和保存图片
      this.$xesLogger.clickMsg({
        params: { clickid: '53.0.0', elemname: 'app内分享', type: this.type, shareScence: scence }
      })
      callAppShare({
        shareType, // 1.网页，2大图，3小程序
        wxMiniId: 'gh_50e4e1c92eda', // 原始id
        wxMiniPath: path,
        wxMiniProgramType: 0, // 正式版：0  测试版：1  体验版：2
        shareScence: scence, // // 1 微信 2 微信朋友圈 3 qq好友 4 qq空间 5 复制链接 32 保存图片
        isOneKeyShare: true, // 是否一键分享
        imgData: this.imgPath,
        title: this.type === 2 ? '暑期夏令营，抽奖嗨不停' : '写作夏令营活动进行中',
        iconUrl:
          this.type === 2
            ? 'https://editor.xesimg.com/tailor/resource/share-poster-1623057564909.png'
            : 'https://editor.xesimg.com/tailor/resource/newshare11-1623253051460.png',

        desc: '好友邀你上名师课，注册即可领取' // 分享描述
      })
    }
  }
}
</script>
<style lang="less" scoped>
.share-poster {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 150;
  width: 100%;
  min-height: 100vh;
  font-size: 0;
  font-family: PingFangSC-Semibold, PingFang SC;
}
</style>
<style lang="less">
.share-modal {
  background: transparent !important;

  .share-content {
    width: 250px;

    .close-btn {
      position: absolute;
      top: 0;
      left: 50%;
      width: 22px;
      height: 22px;
      margin: 20px 0;
      transform: translate(-50%, 0);
    }
  }

  .share-box {
    width: 100%;
    max-height: 400px;
    margin-top: 60px;
    overflow: hidden;
    border-radius: 5px;

    .share-box-img {
      width: 100%;
      height: auto;
      border-radius: 2px;
    }
  }

  .share-box-suipian {
    border: 1px solid #030a55;
  }

  .share-btn-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 80px;
    padding: 0 6px;
    margin: 20px 0;
    background: #f4f5f9;
    border-radius: 8px;
    box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.08);

    .share-btn-item {
      width: 180px;
      height: 100%;
      padding: 12px 0 0 0;
      text-align: center;

      .share-btn-icon {
        width: 36px;
        height: 36px;
        margin-bottom: 4.5px;
      }

      .share-btn-text {
        width: 100%;
        font-size: 12px;
        font-weight: 400;
        line-height: 16.5px;
        text-align: center;
        color: #333;
      }
    }
  }

  .share-h5 {
    width: 100%;
    height: 80px;
    //padding: 20px 20px;
    margin: 20px 0;
    font-size: 14px;
    font-weight: 400;
    //line-height: 40px;
    text-align: center;
    color: #fff;
    //background: #f6f6f6;
    //border-radius: 8px;
  }
}
</style>
